<div *ngIf="shouldShow" class="validation-error-message-container">
  <div [attr.id]="getId" class="error-message mt-3 text-left">
    <p>{{ errorMessage }}</p>
  </div>
  <div class="arrow-down"></div>
</div>
